import { render, staticRenderFns } from "./TypeDialog.vue?vue&type=template&id=a7bf39f6&"
import script from "./TypeDialog.vue?vue&type=script&lang=js&"
export * from "./TypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./TypeDialog.vue?vue&type=style&index=0&id=a7bf39f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports